import React, { useState, useCallback } from "react";
import Label from "../ui/Label";
import CurrenciesSelect from "../CurrenciesSelect";
import { Button } from "@euroland/base-ui";
import { classNames, findLatestDate } from "../../utils";
import {i18n} from "@euroland/libs";
import { minStartingDateInstrumentSelector } from "../../store/slice/trade";
import { useSelector } from "react-redux";
import { renderTextBasedOnTemplate } from "../../store/utils";
import { useCurrencyEnabled, useFormatSetting } from "../../hooks/useCompanySettings";
import { SHORT_DATE_FORMAT, TAB } from "../../constant/common";
import useInstruments from "../../hooks/useInstruments";
import SingleRangePickerDate from "./SingleRangePickerDate";
import { useMainContext } from "../../contexts/MainContext";
import QuadrataSingleRangePickerDate from "./QuadrataSingleRangePickerDate";
// import { formatDate } from "@euroland/libs";

const SharePriceSelection = ({ onSubmit, isQuadrata, isVictor, loading }) => {
  const [currency, setCurrency] = useState("");
  const [{ instruments }] = useInstruments();
  const currencyEnabled = useCurrencyEnabled();
  const [rangePickerVal, setRangePickerVal] = useState({
    from: findLatestDate(instruments).subtract(1, "year").toDate(),
    to: findLatestDate(instruments).toDate(),
  });

  const { tab } = useMainContext();
  const { currentTab } = tab;
  const isSharePriceTab = currentTab === TAB.sharePrice;

  const handleChangeRangePicker = useCallback(data => {
    setRangePickerVal(data);
  }, []);

  const handleChangeCurrencies = useCallback(val => setCurrency(val), []);
  const minStartingDateInstrument = useSelector(minStartingDateInstrumentSelector);

  const handleShowData = () => {
    onSubmit?.({
      currency: currency === i18n.translate("localCurrency") ? "" : currency,
      rangePickerVal,
    });
  };

  const format = useFormatSetting();
  const calendarFormat = format.shortDate || SHORT_DATE_FORMAT;

  // minDate and maxDate of date picker
  const minDate = minStartingDateInstrument ? new Date(minStartingDateInstrument) : null;
  const maxDate = findLatestDate(instruments).toDate();

  const selectedCurrency = currency || i18n.translate("localCurrency");

  return (
    <>
      <div
        className={classNames("historical-selection share-price-selection ", {
          "share-price-selection-quadrata": isQuadrata,
          "hidden-currency": !currencyEnabled,
          victor: isVictor,
        })}
      >
        <div className="historical-selection__wrapper">
          <div className={classNames("historical-selection__inputs")}>
            {isSharePriceTab && (
              <>
                <div className="select-period">
                  <Label>
                    {renderTextBasedOnTemplate(
                      i18n.translate("labelDateVictorSharePrice"),
                      i18n.translate("labelDateVictorSharePrice")
                    )}
                  </Label>
                  {isQuadrata && (
                    <QuadrataSingleRangePickerDate
                      onChange={handleChangeRangePicker}
                      dateFormat={calendarFormat}
                      textCancel={i18n.translate("cancel")}
                      textApply={i18n.translate("apply")}
                      isRtl={window.appSettings.isRtl}
                      minDate={minDate}
                      maxDate={maxDate}
                      value={{
                        from: rangePickerVal?.from,
                        to: rangePickerVal?.to,
                      }}
                    />
                  )}
                  {isVictor && (
                    <>
                      <SingleRangePickerDate
                        onChange={handleChangeRangePicker}
                        dateFormat={calendarFormat}
                        textCancel={i18n.translate("cancel")}
                        textApply={i18n.translate("apply")}
                        isRtl={window.appSettings.isRtl}
                        minDate={minDate}
                        maxDate={maxDate}
                        value={{
                          from: rangePickerVal?.from,
                          to: rangePickerVal?.to,
                        }}
                      />
                      {/* <p className="historical-selection__note">{noteDateTable}</p> */}
                    </>
                  )}
                </div>
                <div className="share-price__currency">
                  <CurrenciesSelect onChange={handleChangeCurrencies} selectedCurrency={selectedCurrency} />

                  {isVictor && (
                    <Button
                      className="historical-selection__submit"
                      onClick={handleShowData}
                      active
                      loading={loading}
                    >
                      {i18n.translate("showDataButton")}
                    </Button>
                  )}
                </div>
              </>
            )}
          </div>
          {/* {isVictor && <p className="historical-selection__note pc">{noteDateTable}</p>} */}
        </div>
        {isQuadrata && (
          <Button
            className="historical-selection__submit historical-selection__submit-quadrata"
            onClick={handleShowData}
            outline
            loading={loading}
          >
            <span className="button-text">{i18n.translate("showDataButton")}</span>
            <span className="fs-icon fs-right-dash-arrow"></span>
          </Button>
        )}
      </div>
      <div
          style={{ position: "absolute", width: 0, height: 0, overflow: "hidden", left: 0, bottom: 0 }}
          role="status"
          aria-live="polite"
        >
          {i18n.translate(loading ? "loading" : "loadingComplete")}
        </div>
    </>
  );
};

export default React.memo(SharePriceSelection);
